import React, { forwardRef } from 'react';

export const InputWithErrorMessage = forwardRef(({errorMessage, children}, ref) => (
    <div className="formInput" ref={ref}>
        {children}
        <span className="validationError" style={{display: (errorMessage && errorMessage.length === 0 ? 'none': 'block')}}>{errorMessage}</span>
    </div>
));
